import { ChangePasswordService, CHANGE_PASSWORD_SERVICE } from './change-password.service';

export class ChangePasswordController {
    private oldPassword: string;
    private newPassword: string;
    private newPasswordConfirm: string;

    static $inject = ["$mdToast", CHANGE_PASSWORD_SERVICE];
    constructor(private $mdToast: ng.material.IToastService, private changePasswordService: ChangePasswordService) {
    }

    private submit() {
        return this.changePasswordService.changePassword(this.oldPassword, this.newPassword, this.newPasswordConfirm);
    }
}


// WEBPACK FOOTER //
// ./app/change-password/change-password.controller.ts